import { ACTIVITY_FEED_SCOPE_LABELS } from "./constants.js";
import { useMemo } from "react";
import { Icon, MultiSelect } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
//#region src/modules/shared/ActivityFeed/SearchFilterActivityFeedScopeMultiSelect.tsx
function SearchFilterActivityFeedScopeMultiSelect({ focused, onChange, onClearSelection, onClick, value }) {
	const options = useMemo(() => {
		return Object.keys(ACTIVITY_FEED_SCOPE_LABELS).map((key) => ({
			label: ACTIVITY_FEED_SCOPE_LABELS[key],
			value: key
		}));
	}, []);
	return /* @__PURE__ */ jsx("div", {
		className: "bg-surface-strong p-xs",
		children: /* @__PURE__ */ jsxs("div", {
			className: "space-y-sm w-full font-bold",
			onClick,
			children: [/* @__PURE__ */ jsxs("span", {
				className: "flex w-full justify-between hover:cursor-pointer",
				children: [/* @__PURE__ */ jsx("span", { children: "Activity Feed Type" }), /* @__PURE__ */ jsx("span", { children: focused ? /* @__PURE__ */ jsx(Icon, { Icon: MdExpandLess }) : /* @__PURE__ */ jsx(Icon, { Icon: MdExpandMore }) })]
			}), focused && /* @__PURE__ */ jsx("div", {
				onClick: (e) => e.stopPropagation(),
				children: /* @__PURE__ */ jsx(MultiSelect, {
					disableSelectAll: true,
					onChangeValue: onChange,
					options,
					placeholder: "Activity Feed Type",
					totalOptions: options.length,
					value: value || [],
					onClearSelection
				})
			})]
		})
	});
}
//#endregion
export { SearchFilterActivityFeedScopeMultiSelect };

//# sourceMappingURL=SearchFilterActivityFeedScopeMultiSelect.js.map